module.exports = __webpack_public_path__ + "img/main_bg.b09fb300.png";